

import firebase from 'firebase'
import Fuse from 'fuse-js-latest'
import _ from 'lodash'
import { event } from 'vue-analytics'
import * as d3 from 'd3'

import moment from 'moment'

const DATEFORMAT = "ddd, MMM D h:mmA"

export default {
  state: {
    isSyncedUser: false,
    org: 'opp',
    colorMain: 'deep-purple',
    myColors: null,
    chapter: 'zz',
    user: null,
    userVrequestDoc: null,
    allVrequestDocs: null,
    registeredMembers: null,
    member: null,
    memberLine: null,
    lines: null,
    matchingMembers: null,
    lineMembers: null,
    allMembers: null,
    sortedLinesAndMembers: null,
    isVueAuthAuthenticated: false,
    checkinsActive: null,
    timeline: null,
    photogallery: null,
    snapshotlisteners: null,
    currentToken: null,
    notifications: [],
    memberStatusDetermined: false
  },
  mutations: {
    addNotification(state, payload){
      state.notifications.push(payload)
    },
    clearNotifications(state, payload){
      state.notifications=[]
    },           
    setMemberStatusDetermined(state, payload){
      state.memberStatusDetermined = payload
    },        
    setCurrentToken(state, payload){
      state.currentToken = payload
    },      
    addSnapshotlistener(state, payload){
      if(!state.snapshotlisteners){
        state.snapshotlisteners = new Array()
      }
      state.snapshotlisteners.push(payload)      
    },    
    setPhotogallery(state, payload){
      state.photogallery = payload
    },     
    setTimeline(state, payload){
      state.timeline = payload
    },    
    setCheckinsActive(state, payload){
      state.checkinsActive = payload
    },
    setIsSyncedUser(state, payload){
      state.isSyncedUser = payload
    },
    isVueAuthAuthenticated (state, payload) {
      state.isVueAuthAuthenticated = payload.isVueAuthAuthenticated
    },    
    setOrg (state, payload) {
        state.org = payload
    },  
    setChapter (state, payload) {
        state.chapter = payload
    },         
    setUser (state, payload) {
      state.user = payload
    },
    setUserphone (state, payload) {
      if(state.user){
        state.user.phone = payload
      }      
    },    
    setMember (state, payload) {
        state.member = payload
     },
     setRegisteredMembers(state, payload){
      state.registeredMembers = payload
     },   
     setMemberLine (state, payload) {
        state.memberLine = payload
     },       
    setLines (state, payload) {
        state.lines = payload
     },
     setMatchingMembers (state, payload) {
        state.matchingMembers = payload
     },
     setLineMembers (state, payload) {
        state.lineMembers = payload
     },
     setAllMembers (state, payload) {
        state.allMembers = payload
     },
     setSortedLinesAndMembers (state, payload) {
        state.sortedLinesAndMembers = payload
     },
     setUserVrequestDoc(state, payload) {
      state.userVrequestDoc = payload      
     },
     setAllVrequestDocs (state, payload){
      state.allVrequestDocs = payload   
     },
     setMyColors (state) {
        var obj = new Object()
        obj.default =  state.colorMain
        obj.lighten1 = state.colorMain + ' lighten-1'
        obj.lighten2 = state.colorMain + ' lighten-2'
        obj.lighten3 = state.colorMain + ' lighten-3'
        obj.lighten4 = state.colorMain + ' lighten-4'
        obj.lighten5 = state.colorMain + ' lighten-5'
        obj.darken1 = state.colorMain + ' darken-1'
        obj.darken2 = state.colorMain + ' darken-2'
        obj.darken3 = state.colorMain + ' darken-3'
        obj.darken4 = state.colorMain + ' darken-4'
        obj.darken5 = state.colorMain + ' darken-5'
        state.myColor = obj
       
     },
     resetUserState (state) {
        state.isSyncedUser= false
        state.org= 'opp'
        state.colorMain= 'deep-purple'
        state.myColors= null
        state.chapter= 'zz'
        state.user= null
        state.userVrequestDoc= null
        state.allVrequestDocs= null
        state.registeredMembers= null
        state.member= null
        state.memberLine= null
        state.lines= null
        state.matchingMembers= null
        state.lineMembers= null
        state.allMembers= null
        state.sortedLinesAndMembers= null
        state.isVueAuthAuthenticated= false
        state.checkinsActive= null
        state.timeline= null
        state.photogallery= null
        state.snapshotlisteners= null      
     }                     
  },
  actions: {
    signUserUp ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.error(error)
          }
        )
    },
    signUserIn ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.error(error)
          }
        )
    },
    retrieveFacebookMember ({dispatch, commit}) {
      return new Promise((resolve, reject) => {        
          dispatch('signUserInFacebook').then(user => {
              commit('setLoading', true)
              commit('clearError')
              //console.log('signUserInFacebook user:', user.user)
              var facebookUser = new Object()
              if(user){
              facebookUser.id = user.user.uid
              facebookUser.displayName = user.user.displayName
              facebookUser.email = user.user.email
              }
              commit('setLoading', false)
              resolve(user)
          })
          
      })
  },  
    retrieveGoogleMember ({dispatch, commit}) {
        return new Promise((resolve, reject) => {        
            dispatch('signUserInGoogle').then(user => {
                commit('setLoading', true)
                commit('clearError')
                console.log('retrieveGoogleMember user:', user)
                var googleUser = new Object()
                if(user){
                  googleUser.id = user.user.uid
                  googleUser.displayName = user.user.displayName
                  googleUser.email = user.user.email
                }
                
               
                commit('setLoading', false)
                resolve(user)
            })
            
        })
    },    
    signUserInLinkedIn ({commit},payload) {
      vueAuth.login(payload.user, payload.requestOptions).then((response) => {
          commit('isVueAuthAuthenticated', {
          isVueAuthAuthenticated: vueAuth.isAuthenticated()
        })
      })

  },    
    signUserInGoogle ({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
              .then(
                user => {
                  commit('setLoading', true)
                  const newUser = {
                    id: user.user.uid,
                    displayName: user.user.displayName,
                    name: user.user.displayName,
                    email: user.user.email,
                    photoUrl: user.user.photoURL
                  }
                  if(newUser.id){
                    console.log('signUserInGoogle newUser',newUser)
                    commit('setUser', newUser)   
                    dispatch('initSyncUserMember', newUser)          
                    commit('setLoading', false)
                    resolve()
                  }
  
                }
              )
              .catch(
                error => {
                  commit('setLoading', false)
                  commit('setError', error)
                  console.error(error)
                  reject()
                }
              )
              
        })

    },
    signUserInFacebook ({dispatch, commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              displayName: user.displayName,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }

            if(newUser.id){
              console.log('signUserInFacebook newUser',newUser)
              console.log('signUserInFacebook committing newUser')
              commit('setUser', newUser)
              console.log('signUserInFacebook this.getters.user',this.getters.user) 
              dispatch('initSyncUserMember', newUser)          
              commit('setLoading', false)
            }

        
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.error(error)
          }
        )
    },
    signUserInGithub ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithPopup(new firebase.auth.GithubAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.error(error)
          }
        )
    },
    signUserInTwitter ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithPopup(new firebase.auth.TwitterAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            var usr = new Object()
            usr.name = user.name
            usr.email = user.email
            usr.photoUrl = user.photoURL
            usr.id = user.uid

            commit('setUser', usr)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.error(error)
          }
        )
    },
    autoSignIn ({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {  
            //console.log('autoSignIn payload:', payload)
            var usr = new Object()
            if(payload.name){
              usr.displayName = payload.name
              usr.name = payload.name
            }
            if(payload.displayName){
              usr.displayName = payload.displayName
              usr.name = payload.displayName
            }
            usr.email = payload.email
            usr.photoUrl = payload.photoURL
            usr.id = payload.uid
            
            commit('setUser', usr)
            console.log('autoSignIn calling initSyncUserMember')
            dispatch('initSyncUserMember', usr) 

            resolve()
        })

    },
    resetPasswordWithEmail ({ commit }, payload) {
      const { email } = payload
      commit('setLoading', true)
      firebase.auth().sendPasswordResetEmail(email)
      .then(
        () => {
          commit('setLoading', false)
          //console.log('Email Sent')
        }
      )
      .catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.error(error)
        }
      )
    },
    logout ({dispatch, commit}) {
      firebase.auth().signOut()
      this.getters.snapshotlisteners.forEach(l=>{
        l.onSnapshot(function () {})
      })
      
      commit('resetUserState')
      commit('resetPostState')
      commit('resetFundraiserState')
      commit('resetMessagesState')
    },
    registerMember ({commit}, payload) {

        commit('setLoading', true)
        commit('clearError')
        

        firebase.firestore().collection(this.getters.org + '/members/' + payload.org).where('isMember', '==', true).where('lineid','==',payload.lineid).where('member', '==', payload.member).get()
        .then(snapshot => {
            snapshot.forEach(doc => {
              firebase.firestore().collection(this.getters.org).doc(doc.id).update({userid: this.getters.user.id, email: this.getters.user.email, verified: false});
              //console.log('updating docid: ' + doc.id + ' w userid=' + this.getters.user.id)
              
              var tmpMemberDoc = doc.data()
              tmpMemberDoc.userid=this.getters.user.id
              commit('setMember', tmpMemberDoc)
              event('member', 'register', 'RegisteredMember' ) //GA EVENT

            });
          })
          .catch(err => {
            console.error('Error getting documents', err);
          });
        commit('setLoading', false)
    },
    requestMemberVerification ({commit}, payload) {
      return new Promise((resolve, reject) => {  
        console.log('inside requestMemberVerification ')
        commit('setLoading', true)
        commit('clearError')

        var tmpObjMember = payload.member
        var tmpObjUser = payload.user

        console.log('inside requestMemberVerification - payload.member: ' + JSON.stringify(payload.member))
        console.log('inside requestMemberVerification - payload.user: ' + JSON.stringify(payload.user))

        var dt = new Date();
        var tmpdatemodified = dt.getTime()  

        var objVerificationRequestRecord = new Object()      
        objVerificationRequestRecord.isactive = true
        objVerificationRequestRecord.datecreated =tmpdatemodified
        objVerificationRequestRecord.isvrequest = true
        //objVerificationRequestRecord.vrequestid = tmpObjMember.org + '_' + tmpObjMember.chapter + '_vrequest_' + tmpObjUser.id
        objVerificationRequestRecord.vrequestid = 'vrequests/' + this.getters.chapter + '/' + tmpObjUser.id
        objVerificationRequestRecord[tmpObjUser.id] = true
        objVerificationRequestRecord.userid =tmpObjUser.id
        objVerificationRequestRecord.email = tmpObjUser.email
        objVerificationRequestRecord.name =tmpObjUser.displayName
        objVerificationRequestRecord.phone =tmpObjUser.phone
        objVerificationRequestRecord.photoUrl =tmpObjUser.photoUrl
        objVerificationRequestRecord.memberfirstname = tmpObjMember.firstname
        objVerificationRequestRecord.memberlastname = tmpObjMember.lastname      
        objVerificationRequestRecord.memberorg = tmpObjMember.org
        objVerificationRequestRecord.memberchapter= tmpObjMember.chapter
        objVerificationRequestRecord.memberlineid = tmpObjMember.lineid
        objVerificationRequestRecord.member = tmpObjMember.member


        objVerificationRequestRecord.verifiers = []
        objVerificationRequestRecord.verifiertemplate = new Object
        objVerificationRequestRecord.verifiertemplate.userid = null
        objVerificationRequestRecord.verifiertemplate.name = null
        objVerificationRequestRecord.verifiertemplate.line = null
        objVerificationRequestRecord.verifiertemplate.dateverified = null
        objVerificationRequestRecord.verifiertemplate.methodofverification = null

        var docRef = firebase.firestore().collection(this.getters.org).doc(objVerificationRequestRecord.vrequestid)
        docRef.get()
        .then(docSnapshot => {
            if (docSnapshot.exists) {
                console.log('inside requestMemberVerification  appending messages in EXISTING document w/ docid: ' + docSnapshot.id)
                docRef.update(objVerificationRequestRecord)
                commit('setLoading', false)   
                event('member', 'register', 'Pending Verification' ) //GA EVENT
                resolve('success')                        
            }else{
              console.log('inside requestMemberVerification  appending messages in NEW document w/ docid: ' + docSnapshot.id)
              docRef.set(
                  objVerificationRequestRecord    
                )
                commit('setLoading', false)   
                event('member', 'register', 'Pending Verification' ) //GA EVENT
                resolve('success')   
            }                    


          })
          .catch(err => {
            console.error('requestMemberVerification--> Error getting documents', err);
            commit('setLoading', false)   
            resolve('error')
          })
        commit('setLoading', false)
      })
    },
    vouchForUser ({commit}, payload) {            
      return new Promise((resolve, reject) => {  
          commit('setLoading', true)   
          var docRef = firebase.firestore().collection(payload.org).doc(payload.vrequestid)
          docRef.get()
          .then(docSnapshot => {
              if (docSnapshot.exists) {
                  //console.log('appending verification in EXISTING document w/ docid: ' + docSnapshot.id)
                  docRef.update({verifiers: firebase.firestore.FieldValue.arrayUnion(payload)})
                  commit('setLoading', false)   
                  event('member', 'register', 'Verification - Vouch' ) //GA EVENT
                  resolve('success')                        
              }else{

                  //console.log('verification doc DNE matching query')

                  commit('setLoading', false)   
                  resolve('success')   
              } 
            })
            .catch(err => {
              console.error('vouchForUser--> Error getting documents', err);
              commit('setLoading', false)   
              resolve('error')
            })
                       
      })
    },   
    addCheckIn ({commit}, payload) {            
      return new Promise((resolve, reject) => {  
          commit('setLoading', true)   
          var tmpMbr = payload.member
          var tmpExpiringMarker = payload.expiringmarker
          
          var tmpExpiryDuration = moment.duration(tmpExpiringMarker.duration.value, tmpExpiringMarker.duration.unit)
          var now = moment().utc()

          var tmpExpiringDate = now.add(tmpExpiryDuration).toISOString() //.format(dateformatexpiry)

          var objCheckin = new Object()
          objCheckin.checkinid = tmpMbr.userid + '_' + now.unix()
          objCheckin.userid = tmpMbr.userid
          objCheckin.name = tmpMbr.firstname + ' ' + tmpMbr.lastname
          objCheckin.line = this.getters.memberLine.lineseason + ' ' + this.getters.memberLine.lineyear
          objCheckin.org = tmpMbr.org
          objCheckin.chapter = tmpMbr.chapter
          objCheckin.expiringdatetime = tmpExpiringDate
          
          objCheckin.position = tmpExpiringMarker.position
          if(tmpExpiringMarker.placename){
            objCheckin.placename = tmpExpiringMarker.placename
          }

          if(tmpExpiringMarker.activity){
            objCheckin.activity = tmpExpiringMarker.activity
          }
          
          if(tmpExpiringMarker.address){
            objCheckin.address = tmpExpiringMarker.address
          }
          if(tmpExpiringMarker.comment){
            objCheckin.comment = tmpExpiringMarker.comment
          }          
        

          //console.log('addCheckIn objCheckin=', objCheckin)
          
          var docRef = firebase.firestore().collection(tmpMbr.org + '/checkins/' + tmpMbr.chapter).doc('list')
          docRef.get()
          .then(function (doc){
            
            if(doc.exists){
              //console.log('addCheckIn doc.exists....updating')
              firebase.firestore().collection(tmpMbr.org + '/checkins/' + tmpMbr.chapter).doc('list')
              .update({checkins: firebase.firestore.FieldValue.arrayUnion(objCheckin)})
              //console.log('addCheckIn updated')
              commit('setLoading', false)   
              event('checkin', 'checkedin', 'Checked In' ) //GA EVENT
              resolve('success')
            }else{
              var arrCheckins = new Array()
              arrCheckins.push(objCheckin)
              //console.log('addCheckIn doc doesnt exist ...adding')
              firebase.firestore().collection(tmpMbr.org + '/checkins/' + tmpMbr.chapter).doc('list')
              .set({checkins: arrCheckins})
              //console.log('addCheckIn doc added')
              commit('setLoading', false)   
              event('checkin', 'checkedin', 'Checked In' ) //GA EVENT
              resolve('success')
            }
          })
          .catch(err => {
            console.error('addCheckIn--> Error getting documents', err);
            commit('setLoading', false)   
            reject('failure')
          })
          commit('setLoading', false)   
         
                       
      })
    },  
    addFileToCheckin ({commit}, payload) {
      return new Promise((resolve, reject) => {     
          commit('setLoading', true)
          var checkin = payload.checkin
          var tmpfile = payload.fileurl
          var tmpfilename = payload.filename
          var tmpfiletype = payload.filetype
          var tmpfilepath = payload.filepath
          var objFile = new Object()
          objFile.fileurl = tmpfile
          objFile.filename =tmpfilename
          objFile.active=true
          if(tmpfiletype){
              objFile.filetype =tmpfiletype
          }                
          if(tmpfilepath){
            objFile.filepath = tmpfilepath
          }              
          objFile.datecreated = new Date().getTime()
          var isImage = payload.isImage
          //console.log('tmpfile', tmpfile)
          //console.log('isImage', isImage)
          //console.log('objFile', objFile)
          var docRef = firebase.firestore().collection(checkin.org + '/checkins/' + checkin.chapter).doc('list')
          docRef.get()
          .then(function (doc){
            
            if(doc.exists){
              //console.log('addCheckIn doc.exists....updating')
              var checkinDoc = doc.data()
              const checkinObjToUpdateWithImage = checkinDoc.checkins.find(c=>{ //my checkin obj to delete
                return c.checkinid === checkin.checkinid
              })
              var updatedCheckinObj = new Object()
              updatedCheckinObj =  Object.assign(updatedCheckinObj,checkinObjToUpdateWithImage )//my replacement checkin obj b4 new image
              
              var docRemoveRef = firebase.firestore().collection(checkin.org + '/checkins/' + checkin.chapter).doc('list')
              //console.log('removeCheckIn without updated image [before]', checkinObjToUpdateWithImage)   
              docRemoveRef              
              .update({checkins: firebase.firestore.FieldValue.arrayRemove(checkinObjToUpdateWithImage)})
              //console.log('removeCheckIn without updated image [after]')  

              
              if(!updatedCheckinObj.images){
                updatedCheckinObj.images = new Array()
              }
              updatedCheckinObj.images.push(objFile) //my replacement checkin obj w/ new image
              //console.log('addCheckIn with updated image [before]', updatedCheckinObj)
              var docUpdateRef = firebase.firestore().collection(checkin.org + '/checkins/' + checkin.chapter).doc('list')
              docUpdateRef              
              .update({checkins: firebase.firestore.FieldValue.arrayUnion(updatedCheckinObj)})
              //console.log('addCheckIn with updated image [after]')


 
              commit('setLoading', false)   
              event('checkin', 'fileupload', 'Image' ) //GA EVENT
              resolve('success')
            }
          })
          .catch(err => {
            console.error('addCheckIn--> Error getting documents', err);
            commit('setLoading', false)   
            resolve('failure')
          })

      })
    },        
    addFileToGallery ({commit}, payload) {
      return new Promise((resolve, reject) => {     
          commit('setLoading', true)
          var tmpmbr = payload.member
          var tmpfile = payload.fileurl
          var tmpfilename = payload.filename
          var tmpfiletype = payload.filetype
          var tmpfilepath = payload.filepath
          var tmpcaption = payload.caption
          var objFile = new Object()
          objFile.active=true
          objFile.fileurl = tmpfile
          objFile.filename =tmpfilename
          objFile.org = tmpmbr.org
          objFile.chapter = tmpmbr.chapter
          objFile.name = tmpmbr.firstname + ' ' + tmpmbr.lastname
          objFile.line = tmpmbr.lineid
          if(tmpfiletype){
              objFile.filetype =tmpfiletype
          }      
          if(tmpcaption){
            objFile.caption =tmpcaption
          }       
          if(tmpfilepath){
            objFile.filepath = tmpfilepath
          }                     
          objFile.datecreated = new Date().getTime()
          var isImage = payload.isImage
          //console.log('tmpfile', tmpfile)
          //console.log('isImage', isImage)
          //console.log('objFile', objFile)

          //console.log('addFileToGallery getting docref')

          var docRef = firebase.firestore().collection(tmpmbr.org + '/gallery/' + tmpmbr.chapter).doc('list')

          
          var galleryEntry = new Object()
          objFile.picid = tmpmbr.userid + '.' + objFile.datecreated
          galleryEntry[tmpmbr.userid + '.' + objFile.datecreated ] = objFile

          //console.log('addFileToGallery calling docref set')
          docRef.set(galleryEntry,{merge:true})
          .then(function (){
            //console.log('addFileToGallery success')
            event('gallery', 'fileupload', 'Image' ) //GA EVENT
            resolve('success') 
          })
          .catch(err => {
            console.error('addFileToGallery--> Error getting documents', err);
            commit('setLoading', false)   
            reject('failure')
          })

          commit('setLoading', false)   
          resolve('success')        
          

      })
    },  
    updateNotificationToken ({commit}, payload) {
      return new Promise((resolve, reject) => {     
          commit('setLoading', true)
          var tmpmbr = payload.member
          var tmptoken = payload.token

          var objToken = new Object()
          objToken.active=true
          objToken.org = tmpmbr.org
          objToken.chapter = tmpmbr.chapter
          objToken.name = tmpmbr.firstname + ' ' + tmpmbr.lastname
          objToken.line = tmpmbr.lineid
          objToken.token = tmptoken
          objToken.datecreated = new Date().getTime()


          var docRef = firebase.firestore().collection(tmpmbr.org + '/notifytokens/' + tmpmbr.chapter).doc('list')

          
          var tokenEntry = new Object()          
          tokenEntry[tmpmbr.userid] = objToken

          //console.log('addFileToGallery calling docref set')
          docRef.set(tokenEntry,{merge:true})
          .then(function (){
            //console.log('addFileToGallery success')
            event('notification', 'newtoken', 'newtoken' ) //GA EVENT
            resolve('success') 
          })
          .catch(err => {
            console.error('updateNotificationToken--> Error getting documents', err);
            commit('setLoading', false)   
            reject('failure')
          })

          commit('setLoading', false)   
          resolve('success')        
          

      })
    },      
    updateFileFromGallery ({commit}, payload) {
      return new Promise((resolve, reject) => {     
          commit('setLoading', true)
          var tmpmbr = payload.member
          var tmppicupdates = payload.picupdates
          if(tmppicupdates.picid){

            var docRef = firebase.firestore().collection(tmpmbr.org + '/gallery/' + tmpmbr.chapter)
            docRef
            .get().then(function(docRefSnap) {
              docRefSnap.forEach(doc=> {
                  var photoGalleryDoc = doc.data()
                  var photoGalleryDocId = doc.id
                  if(photoGalleryDoc.hasOwnProperty(tmppicupdates.picid)){
                    var currPhotoObj = photoGalleryDoc[tmppicupdates.picid]
                    var updatedPhotoMap = new Object ()
                    updatedPhotoMap[currPhotoObj.picid] = Object.assign(currPhotoObj, tmppicupdates)
                    
                    docRef.doc(photoGalleryDocId).set(updatedPhotoMap, {merge: true}).then(function(){
                      //console.log('updateFileFromGallery success')
                      event('gallery', 'update', 'Updated Image Caption' ) //GA EVENT
                      resolve('success')
                    }
                      
                    ).catch(err=>{
                      reject('failure')
                    })
                  }
              })
            })
          }
          commit('setLoading', false)   
          resolve('success')        
          

      })
    },       
    updateProfilePic ({commit}, payload) {
      return new Promise((resolve, reject) => {     
          commit('setLoading', true)
          var tmpmbr = payload.member
          var tmpfile = payload.fileurl
          var tmpfilename = payload.filename
          var tmpfiletype = payload.filetype
          var tmpfilepath = payload.filepath
          var objFile = new Object()
          objFile.active=true
          objFile.fileurl = tmpfile
          objFile.filename =tmpfilename
          if(tmpfiletype){
              objFile.filetype =tmpfiletype
          }         
          if(tmpfilepath){
            objFile.filepath = tmpfilepath
          }                     
          objFile.datecreated = new Date().getTime()
          var isImage = payload.isImage
          //console.log('tmpfile', tmpfile)
          //console.log('isImage', isImage)
          //console.log('objFile', objFile)

          //console.log('updateProfilePic getting docref')

          var docRef = firebase.firestore().collection(tmpmbr.org + '/members/' + tmpmbr.chapter).doc(tmpmbr.lineid + '.' + tmpmbr.member) 

          //console.log('updateProfilePic calling docref set')
          docRef.set({profilepic: objFile},{merge:true})
          .then(function (){
            event('profilepic', 'updated', 'Profile Pic Update' ) //GA EVENT
            //console.log('updateProfilePic success')
            resolve('success') 
          })
          .catch(err => {
            console.error('updateProfilePic--> Error getting documents', err);
            commit('setLoading', false)   
            reject('failure')
          })

          commit('setLoading', false)   
          resolve('success')        
          

      })
    },            
    initSyncUserMember  ({dispatch, commit}, payload) {
      //console.log('called initSyncUserMember')

      /*
      var iTimeout = 1
      while(this.getters.user===null && iTimeout<5){
        iTimeout = iTimeout + 1
        setTimeout(function(){ 
          console.log('initSyncUserMember waiting for user to be set')
        }, 1000);

      }
*/
        var tmpuserid = payload.id
        var pathVreqcoll = this.getters.org + '/vrequests/' + this.getters.chapter 

        console.log('called initSyncUserMember pathVreqcoll', pathVreqcoll)
        console.log('called initSyncUserMember tmpuserid', tmpuserid)

            console.log('initSyncUserMember  - LOAD USERS VERIFICATION REUQESTS',payload)
            //LOAD USERS VERIFICATION REUQESTS
            commit('setLoading', true)
            //const userVrequestCollection = firebase.firestore().collection(this.getters.org).where('memberchapter', '==', this.getters.chapter).where('isactive', '==', true).where('isvrequest', '==', true).where(tmpuserid, '==', true)
            
            const userVrequestCollection = firebase.firestore().collection(pathVreqcoll).where('memberchapter', '==', this.getters.chapter).where('isactive', '==', true).where('isvrequest', '==', true).where(tmpuserid, '==', true)
            userVrequestCollection
            .onSnapshot((userVrequestRef) => {
              
              //console.log('initSyncUserMember--userVrequestRef', userVrequestRef)
              userVrequestRef.forEach((doc) => {//very crappy code TODO: FIX THIS dont loop, just get the one doc
                const tmpvDoc = doc.data()
                tmpvDoc.datecreated = moment(tmpvDoc.datecreated).format(DATEFORMAT)
                //console.log('initSyncUserMember--userVrequestRef-- tmpvDoc', tmpvDoc)
                commit('setUserVrequestDoc', tmpvDoc)
              })

              /*              
              //console.log('initSyncUserMember  - VERIFICATION REUQESTS userVrequestRef',userVrequestRef)
              if(userVrequestRef.size>0){
                //console.log('initSyncUserMember  - FOUND USERS VERIFICATION REUQESTS',userVrequestRef[0].data())
                const tmpVrequest = userVrequestRef.docs[0].data()
                commit('setUserVrequestDoc', tmpVrequest)
              }*/
            })
            commit('addSnapshotlistener', userVrequestCollection)

            //console.log('initSyncUserMember  - LOAD USERS CORRESPONDING REGISTERED MEMBER')
            var tmpUserMember = null
            //LOAD USER'S CORRESPONDING REGISTERED MEMBER
            const userMemberCollection = firebase.firestore().collection(this.getters.org + '/members/' + this.getters.chapter).where('chapter', '==', this.getters.chapter).where('isMember', '==', true).where('userid', '==', tmpuserid)
            userMemberCollection
            .onSnapshot((userMemberRef) => {
              userMemberRef.forEach((doc) => {//very crappy code TODO: FIX THIS dont loop, just get the one doc
                tmpUserMember = doc.data()
                //console.log('initSyncUserMember setMember tmpUserMember:',tmpUserMember)
                commit('setMember', tmpUserMember)  
                commit('setMemberStatusDetermined', true)
                    //LOAD USER'S CORRESPONDING REGISTERED MEMBER's LINE and LINE MEMBERS
                    //console.log('initSyncUserMember tmpUserMember:',tmpUserMember)
                    if(tmpUserMember){
                      /*
                      const userMembersLineCollection = firebase.firestore().collection(this.getters.org).where('chapter', '==', this.getters.chapter).where('isLine', '==', true).where('lineid', '==', tmpUserMember.lineid)
                      userMembersLineCollection
                      .onSnapshot((userMemberLineRef) => {
                        userMemberLineRef.forEach((doc) => {//very crappy code TODO: FIX THIS dont loop, just get the one doc
                          const tmpUserMemberLine = doc.data()
                          commit('setMemberLine', tmpUserMemberLine)  
                        })})        
                      */
                     //console.log('opp/lines/zz/list before call:' + this.getters.org + '/lines/' + this.getters.chapter)
                     var linesRef = firebase.firestore().collection(this.getters.org + '/lines/' + this.getters.chapter).doc('list')                     

                     linesRef
                     .onSnapshot(function(doc) {
                      if (doc.exists) {
                        //console.log('opp/lines/zz/list doc.data()', doc.data())
                        var linesDoc = doc.data().lines
                        var lid = tmpUserMember.lineid
                        var tmpUserMemberLine = linesDoc.find(function(rec){return rec.lineid===lid && rec.isLine===true})
                        //if(tmpUserMemberLine && tmpUserMemberLine.length>0){
                        //  tmpUserMemberLine = tmpUserMemberLine[0]
                        //}
                        //console.log("setLines ", linesDoc);
                        commit('setLines', linesDoc)  //LOAD ALL LINES
                        //console.log("setMemberLine ", tmpUserMemberLine);
                        commit('setMemberLine', tmpUserMemberLine)  //LOAD USER'S CORRESPONDING REGISTERED MEMBER's LINE
                      }else{

                      }

                        
                     })
                     commit('addSnapshotlistener', linesRef)               

                        const userLineMembersCollection = firebase.firestore().collection(this.getters.org + '/members/' + this.getters.chapter).where('chapter', '==', this.getters.chapter).where('isMember', '==', true).where('lineid', '==', tmpUserMember.lineid)
                        userLineMembersCollection
                        .onSnapshot((userLineMembersCollectionRef) => {
                          var tmpUserLineMembers = userLineMembersCollectionRef.docs.map(function (documentSnapshot){
                            return documentSnapshot.data();
                          })  
                          commit('setLineMembers', tmpUserLineMembers)                 
                          
                        })
                        commit('addSnapshotlistener', userLineMembersCollection)         
                        //console.log('calling initFundraiserSynch from initSyncUserMember',tmpUserMember)
                        //dispatch('initFundraiserSynch', tmpUserMember) 


                        //SET TIMELINE
                        commit('setLoading', true)
                        var activityDocRef = firebase.firestore().collection(this.getters.org + '/activitylogs/' + this.getters.chapter).doc('list')
                        activityDocRef
                        .onSnapshot(function (doc){
                          const DATEFORMAT_ACTIVITY = 'YYYY-MM-DDThh:mm a'
                          if(doc.exists){
                            var arrActivityByDay = new Array()
                            var arrActivity = doc.data().entries
                            if(arrActivity && arrActivity.length>0){
                              arrActivity = arrActivity.filter(function(a){
                                var rtn =false
                                if(a.scope==='chapter'){
                                  rtn = true
                                }else if(a.scope==='line' && a.line===tmpUserMember.lineid){
                                  rtn = true
                                }else if(a.scope==='group' && a.participants.includes(tmpUserMember.userid) ){
                                  rtn = true 
                                }else if(a.scope==='member' && a.participants.includes(tmpUserMember.userid)  ){
                                  rtn = true
                                }                                  
                                return rtn
                              })
                              arrActivity = arrActivity.reverse()
                              arrActivity = arrActivity.map(a =>{
                                a.datetime = moment(a.datetime).format(DATEFORMAT_ACTIVITY)
                                if(a.expiringdatetime){
                                  a.expiringdatetime = moment(a.expiringdatetime).format(DATEFORMAT_ACTIVITY)
                                }
                                
                                return a
                              })

                              //console.log('setTimeline arrActivity',arrActivity)
                              arrActivityByDay  = d3.nest()
                              .key(function(d) { return d.datetime.substring(0,10); }).sortKeys(d3.descending)
                              .entries(arrActivity)   

                              //console.log('setTimeline arrActivityByDay',arrActivityByDay)
                            }
            
                            commit('setTimeline', arrActivityByDay)                 
                          }
                        })
                        commit('addSnapshotlistener', activityDocRef)                                      

                        const photoGalleryCollection = firebase.firestore().collection(this.getters.org + '/gallery/' + this.getters.chapter)
                        photoGalleryCollection
                        .onSnapshot((photoGalleryRef) => {
                          
                          //console.log('initSyncUserMember--photoGalleryRef', photoGalleryRef)
                          var photoObjects = new Array()
                          photoGalleryRef.forEach((doc) => {
                            const photoGalleryDoc = doc.data()
                            for(var key in photoGalleryDoc) {
                              var photoObject = photoGalleryDoc[key]
                              //console.log('photoObject',photoObject)
                              if(photoObject.active && photoObject.active===true){
                                photoObject.datecreated = moment(photoObject.datecreated).format(DATEFORMAT)
                                photoObjects.unshift(photoObject)
                              }
                            }
                            commit('setPhotogallery', photoObjects)
                          })
            

                        })
                        commit('addSnapshotlistener', photoGalleryCollection)                        
                    }


              })})
              
              commit('addSnapshotlistener', userMemberCollection)   



            //LOAD ALL LINES if it wasn't loaded previously in the member stuff above
            if(this.getters.lines===null){
              var linesRef = firebase.firestore().collection(this.getters.org + '/lines/' + this.getters.chapter).doc('list')
              linesRef
              .onSnapshot(function(doc) {
               if (doc.exists) {
                 //console.log('opp/lines/zz/list doc.data()', doc.data())
                 var linesDoc = doc.data().lines
                 commit('setLines', linesDoc)  //LOAD ALL LINES
               }                 
              })
              commit('addSnapshotlistener', linesRef)
            }

              
            //LOAD ALL MEMBERS
            const membersCollection = firebase.firestore().collection(this.getters.org + '/members/' + this.getters.chapter).where('chapter', '==', this.getters.chapter).where('isMember', '==', true)
            membersCollection
            .onSnapshot((membersCollectionRef) => {
              var tmpMembers = membersCollectionRef.docs.map(function (documentSnapshot){
                return documentSnapshot.data();
              })
              commit('setAllMembers', tmpMembers)    
              firebase.firestore().collection(this.getters.org + '/lines/' + this.getters.chapter).doc('list').get()
              .then(function (doc) {
                var tmpLines =[]
                if(doc.exists){
                  tmpLines = doc.data().lines
                }

                  var tmpAllMembers = tmpMembers                  
                  var tmpArrSortedLinesAndMembers = new Array()
                  var i 
                  for (i = 0; i < tmpLines.length; i++) { 
                    const tmpLineid = tmpLines[i].lineid
                    var tmpLineMembers = tmpAllMembers.filter(function(mbr){return mbr.lineid===tmpLineid})
                    tmpLines[i].linemembers = tmpLineMembers
                    tmpArrSortedLinesAndMembers.push(tmpLines[i])                
                  } 
                  commit('setSortedLinesAndMembers',tmpArrSortedLinesAndMembers)  
                })
                .catch(err => {
                  console.error('Error setting setSortedLinesAndMembers', err)
                })            
            })
            commit('addSnapshotlistener', membersCollection)               
                   


            
            //console.log('initSyncUserMember  - LOAD ALL REGISTERED MEMBER')
            //LOAD ALL REGISTERED MEMBER
            const registeredMembersCollection = firebase.firestore().collection(this.getters.org + '/members/' + this.getters.chapter).where('chapter', '==', this.getters.chapter).where('isMember', '==', true).where('userid', '==', tmpuserid)
            registeredMembersCollection
            .onSnapshot((registeredMembersRef) => {
              var tmpMembers = []
              registeredMembersRef.forEach((doc) => {
                const tmpMember = doc.data()
                tmpMember.id = doc.id

                tmpMembers.push(tmpMember);
              })
              commit('setRegisteredMembers', tmpMembers) 

            })     
            commit('addSnapshotlistener', registeredMembersCollection)        


            //console.log('initSyncUserMember  - LOAD ALL MATCHING MEMBERS (SUGGESTIONS)')
            //LOAD ALL MATCHING MEMBERS
            var tmpDisplayName = payload.displayName
            var tmpEmailBeg = payload.email
            if(tmpEmailBeg){
                var atPos = tmpEmailBeg.indexOf('@')
                if(atPos>-1){
                    tmpEmailBeg= tmpEmailBeg.split('@')[0]
                }
            }
      
            const matchingMembersCollection = firebase.firestore().collection(this.getters.org + '/members/' + this.getters.chapter).where('chapter', '==', this.getters.chapter).where('isMember', '==', true).where('userid', '==', null)
            matchingMembersCollection
            .onSnapshot((matchingMembersRef) => {
              var arrayOfMembers = matchingMembersRef.docs.map(function (documentSnapshot){
                  return documentSnapshot.data();
              })
              var options = {
                  shouldSort: true,
                  threshold: 0.6,
                  location: 0,
                  distance: 100,
                  maxPatternLength: 120,
                  minMatchCharLength: 1,                    
                  //keys: ['firstname', 'lastname','member']
                  keys: ['firstname', 'lastname','member', 'emailalts']
                }                

              ////console.log('arrayOfMembers', arrayOfMembers)
              var fuseDisplayName = new Fuse(arrayOfMembers, options)
              var fuseEmailBeg = new Fuse(arrayOfMembers, options)
              var searchfuseDisplayName = fuseDisplayName.search(tmpDisplayName)
              var searchfuseEmailBeg = fuseEmailBeg.search(tmpEmailBeg)
              //console.log('fuseDisplayName',searchfuseDisplayName)
              //console.log('fuseEmailBeg',searchfuseEmailBeg)


              var arrMatchingMembers = _.unionBy(searchfuseDisplayName, searchfuseEmailBeg, "member");
              //console.log('arrMatchingMembers',arrMatchingMembers)

              commit('setMatchingMembers', arrMatchingMembers)
              commit('setMemberStatusDetermined', true)

            })
            commit('addSnapshotlistener', matchingMembersCollection)               

            //LOAD ALL VERIFICATION REUQESTS
            commit('setLoading', true)
            //const allVrequestCollection = firebase.firestore().collection(this.getters.org).where('memberchapter', '==', this.getters.chapter).where('isactive', '==', true).where('isvrequest', '==', true)
            const allVrequestCollection = firebase.firestore().collection(pathVreqcoll).where('memberchapter', '==', this.getters.chapter).where('isactive', '==', true).where('isvrequest', '==', true)
            allVrequestCollection
            .onSnapshot((allUserVrequestRef) => {
              
              var vdocs = []
              allUserVrequestRef.forEach((doc) => {//very crappy code TODO: FIX THIS dont loop, just get the one doc
                const tmpvDoc = doc.data()
                tmpvDoc.datecreated = moment(tmpvDoc.datecreated).format(DATEFORMAT)
                vdocs.push(tmpvDoc)                
              })
              commit('setAllVrequestDocs', vdocs) 
            })
            commit('addSnapshotlistener', allVrequestCollection)

            commit('setLoading', true)
            var checkinsDocRef = firebase.firestore().collection(this.getters.org + '/checkins/' + this.getters.chapter).doc('list')
            checkinsDocRef
            .onSnapshot(function (doc){
              
              if(doc.exists){
                var arrCheckins = doc.data().checkins
                if(arrCheckins && arrCheckins.length>0){
                  arrCheckins = arrCheckins.filter(function(c){
                    //console.log('moment() ' , moment().utc())
                    //console.log('moment(c.expiringdatetime)', moment(c.expiringdatetime).utc())
                    return moment().utc().isBefore(moment(c.expiringdatetime).utc() )
                  })

                  arrCheckins = arrCheckins.map(chin =>{
                    chin.expiringdatetime = moment(chin.expiringdatetime).format(DATEFORMAT)
                    return chin
                  })
                }

                commit('setCheckinsActive', arrCheckins)                 
              }
            })
            commit('addSnapshotlistener', checkinsDocRef)       
            
       
                  

            commit('setLoading', false)   
            commit('setIsSyncedUser', true)   
               
    }
  },

  getters: {
    org (state) {
        return state.org
    },  
    chapter (state) {
        return state.chapter
    },         
    user (state) {
      return state.user
    },
    userphone (state) {
      if(state.user && state.user.phone){
        return state.user.phone
      }else{
        return null
      }
    },    
    member (state) {
        return state.member
    },
    userVrequestDoc (state){
      return state.userVrequestDoc
    },
    allVrequestDocs (state){
      return state.allVrequestDocs
    },
    memberLine (state) {
        return state.memberLine
    },    
    lines (state) {
        return state.lines
    },
    registeredMembers (state){
      return state.registeredMembers
    },
    allMembers (state) {
      return state.allMembers
    },    
    matchingMembers (state) {
        return state.matchingMembers
    },
    sortedLinesAndMembers(state){
      return state.sortedLinesAndMembers
    },
    lineMembers (state) {
        return state.lineMembers
    },
    colorMain (state) {
        return state.colorMain
    },
    myColor (state) {
        return state.myColor
    },
    isSyncedUser(state){
      return state.isSyncedUser
    },
    checkinsActive(state){
      return state.checkinsActive
    },
    timeline(state){
      return state.timeline
    },
    photogallery(state){
      return state.photogallery
    },
    snapshotlisteners(state){
      return state.snapshotlisteners
    },
    currentToken(state){
      return state.currentToken
    },
    notifications(state){
      return state.notifications
    },
    memberStatusDetermined(state){
      return state.memberStatusDetermined
    }                                                                    
  }
}